module.exports = __webpack_public_path__ + "static/bld-venmo-qr-a581c4a20e0d8cc0c938c95dae02ed35.png";